import { canUseDOM } from 'exenv';
import React, { Component } from 'react';
import withRouter from 'react-router/withRouter';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import highlightShare from 'highlight-share/dist/highlight-share';
import * as twitterSharer from 'highlight-share/dist/sharers/twitter';
import * as facebookSharer from 'highlight-share/dist/sharers/facebook';
import EventModel from '../../../../utils/tracking/models';
import set from 'lodash/set';
import get from 'lodash/get';
import extend from 'lodash/extend';
import throttle from 'lodash/throttle';
import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import PostsContainer from '../../../components/post/container';
import Dianomi from '../../../components/dianomi/dianomi_script';
import VideoModule from '../../../components/video_module/video_module';
import matchMediaDesktop from '../../../../utils/client_util';
import trackThirdPartyJS from '../../../../client/utils/third_party_trackers/trackThirdPartyJS';
import { UserContext } from '../../../components/context/userContext';

let scriptjs = false;

if (canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = require('scriptjs');
}

class News extends Component {
  constructor() {
    super();

    this.isDesktop = false;
    this.setScrollEvents = throttle(() => {
      const { scrollY, innerHeight } = this.window;
      this.setInviewPost(scrollY, innerHeight);
    }, 100);
    this.onPaginateClick = this.onPaginateClick.bind(this);
    this.playerScriptIds = [
      'QV73eWiB',
      '4h5SWQPt',
      'Pafg29um',
      '27mBLzWL',
      'i70nsZ8K',
      'Lrp0YsKC',
      'wGNMZweZ',
      'kMmGs8qw',
      'WXJihrBk',
      'iqio3VCM',
      'OolwHeKf',
      'FsIzKJce',
      'r04h3Jdn',
      'RvGXj7in',
      'flarUGPa',
      'HzdTLaau',
      'gAy6i1bi',
      'RqEFED7X',
      'vp2iCnvh',
      'b2BPV4nc'
    ];
  }

  componentDidMount() {
    this.window = window;
    this.activePost = null;
    this.isDesktop = matchMediaDesktop();
    this.trackedPosts = [];
    window.addEventListener('scroll', this.setScrollEvents);

    if (get(this.props.config, 'featureFlags.textToShare')) {
      this.selectionShare = highlightShare({
        selector: '.post__body',
        sharers: [facebookSharer, twitterSharer],
        onOpen: element => {
          element.setAttribute('id', `user_highlight--${this.activePost}`);

          const highlightShareEvent = new EventModel(
            'Highlight Share',
            'articleFormat',
            'hovered',
            'exposed',
            this.getPercentIntoPost(element)
          );

          highlightShareEvent.triggerTrackingEvent(
            'default-click',
            highlightShareEvent.getTrackingObject()
          );
        }
      });
      this.selectionShare.init();
    }
  }

  componentDidUpdate() {
    this.posts = this.getPostElements();

    if (canUseDOM && get(this.posts, 'length')) {
      if (!window.instgrm) {
        scriptjs('//platform.instagram.com/en_US/embeds.js', () => {
          window.instgrm.Embeds.process();
        });
      } else {
        window.instgrm.Embeds.process();
      }

      // if (!window.twttr.widgets) {
      //   scriptjs('//platform.twitter.com/widgets.js', () => {
      //     window.twttr.widgets.load();
      //   });
      // } else {
      //   window.twttr.widgets.load();
      // }
      scriptjs('//platform.twitter.com/widgets.js', () => {
        window.twttr.widgets.load();
      });
    }
  }

  componentWillUnmount() {
    this.window.removeEventListener('scroll', this.setScrollEvents);
    if (get(this.props.config, 'featureFlags.textToShare')) {
      this.selectionShare.destroy();
    }
  }

  onPaginateClick(data) {
    const url = `/news/${data.selected + 1}`;
    this.props.nextPage(url);
  }

  getPercentIntoPost(element) {
    const post = document.querySelector(`#post__wrapper-${this.activePost}`);
    const { top = 0, height = 0 } = post.getBoundingClientRect() || {};
    const postHeight = height - top;
    const highlightPosition = parseInt(element.style.top || 0, 10) - top;
    const percent = highlightPosition / postHeight * 100;
    return percent;
  }

  setInviewPost(windowPosition, screenHeight) {
    if (!this.posts || !get(this.posts, 'length')) {
      return false;
    }

    // Set url to /news if at top of screen.
    if (windowPosition === 0) {
      const page = get(this.props.match, 'params.page');
      const newsUrl = page ? `/news/${page}` : '/news';
      window.history.replaceState({}, '', newsUrl);
      this.activePost = null;
      return false;
    }

    const triggerPoint = windowPosition + screenHeight / 2;
    for (let i = 1; i <= this.posts.length; i += 1) {
      const post = this.posts[i - 1];
      const sectionTopPosition = post.offsetTop;
      const sectionBottomPosition = sectionTopPosition + post.clientHeight;
      const { id, slug } = post.dataset;
      const postId = parseFloat(id);

      if (
        this.activePost !== postId &&
        sectionTopPosition <= triggerPoint &&
        sectionBottomPosition > triggerPoint
      ) {
        const postData = get(this.props.categoryAllFeed, `posts[${i - 1}]`, {});
        this.activePost = postId;
        this.setActiveSocial(post);

        window.history.replaceState({}, '', `/${postId}/${slug}`);

        if (this.trackedPosts.indexOf(this.activePost) === -1) {
          this.trackedPosts.push(this.activePost);
          this.refreshThirdPartyTrackers(postData, i);
        }
      }
    }
    return false;
  }

  getPostElements() {
    return document.querySelectorAll('.post__body');
  }

  setActiveSocial(post) {
    const activeClass = 'social--active';
    const activeSocial = document.querySelector(`.${activeClass}`);

    if (activeSocial) {
      activeSocial.classList.remove(activeClass);
    }

    const activePost = post || document.querySelector('.post__wrapper');
    if (activePost) {
      activePost.querySelector('.social').classList.add(activeClass);
    }
  }

  refreshThirdPartyTrackers(postData, pageNumber) {
    const { config } = this.props;
    const currentActivePostState = {
      context: {
        site: get(config, 'site'),
        type: 'post',
        postData
      },
      config
    };
    document.title = get(postData, 'title');
    trackThirdPartyJS(currentActivePostState, pageNumber);

    this.context.retriggerPianoPost(postData, pageNumber);
  }

  renderNewsSection(numPosts, firstSection = false, playerIds) {
    const origPosts = get(this.props, 'categoryAllFeed.posts', []);
    let { posts } = this;
    let slice = numPosts;
    const totalPosts = get(posts, 'length');

    if (!totalPosts) return null;

    if (totalPosts <= numPosts) {
      slice = totalPosts;
    }

    posts = this.posts.splice(0, slice);
    posts = posts.map(postData => {
      if (postData.isVideoPermalink || get(postData, 'posterVideo.feedId')) {
        const postIndex = findIndex(origPosts, { id: postData.id });
        if (!playerIds[postIndex]) {
          set(postData, 'playerScriptId', 'G2hQKLvX');
        } else {
          set(postData, 'playerScriptId', playerIds[postIndex]);
        }
      }
      return postData;
    });

    return (
      <PostsContainer
        {...this.props}
        posts={posts}
        combinedAdModel={this.combinedAdModel}
        isDesktop={this.isDesktop}
        isFirstPost={firstSection}
        pageNum={1}
        videoAdData={get(this.props.categoryPage, 'ads.model', {})}
      />
    );
  }

  render() {
    const { categoryAllFeed } = this.props;
    this.posts = cloneDeep(get(categoryAllFeed, 'posts', []));

    if (
      this.props.categoryPage.error ||
      this.props.categoryFeaturedFeed.error
    ) {
      return (
        <section className="category-page">
          <article className="category-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.categoryPage.isLoading) {
      return (
        <section className="category-page">
          <article className="category-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const { config, match } = this.props;
    const { totalPosts, totalPages } = categoryAllFeed;
    const { page } = match.params;
    const adData = get(this.props, 'categoryPage.ads');
    this.combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const currentSite = get(config, 'site');

    return (
      <section className="category-page category-page--news">
        {this.renderNewsSection(3, true, this.playerScriptIds)}

        <Dianomi
          initialPageLoad={get(this.props, 'config.initialPageLoad')}
          site={currentSite}
          config={config}
        />

        {this.renderNewsSection(5, false, this.playerScriptIds)}

        <VideoModule
          config={config}
          type="category"
          data={this.props.categoryVideo}
          playerid="HliaKwd3"
          stories={this.props.categoryVideo.playlist}
          currentSite={currentSite}
          isPost={true}
        />

        {this.renderNewsSection(3, false, this.playerScriptIds)}
        {this.renderNewsSection(5, false, this.playerScriptIds)}
        {this.renderNewsSection(4, false, this.playerScriptIds)}

        <div className="pagination__meta">
          <div className="pagination__container">
            <h2 className="pagination__count pagination__count--bottom">
              {totalPosts} Stories
            </h2>
            <ReactPaginate
              forcePage={page ? parseInt(page, 10) - 1 : 0}
              onPageChange={this.onPaginateClick}
              pageCount={totalPages}
              pageRangeDisplayed={2}
              marginPagesDisplayed={1}
              previousLabel="Prev"
              nextLabel="Next"
              breakLabel="..."
              containerClassName="pagination"
              pageClassName="pagination__page"
              activeClassName="pagination__page pagination__page--active"
              previousClassName="pagination__page pagination__page--prev"
              nextClassName="pagination__page pagination__page--next"
              breakClassName="pagination__page pagination__page--break"
              pageLinkClassName="pagination__link"
              previousLinkClassName="pagination__link"
              nextLinkClassName="pagination__link"
              disabledClassName="pagination__link--disabled"
            />
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    categoryFeaturedFeed: {
      source: get(state, 'categoryFeaturedFeed.source') || '',
      featured: get(state, 'categoryFeaturedFeed.featured') || [],
      top: get(state, 'categoryFeaturedFeed.top') || [],
      category: get(state, 'categoryFeaturedFeed.category') || {},
      error: get(state, 'categoryFeaturedFeed.error') || false
    },
    categoryVideo: {
      playlist: get(state, 'categoryVideo.data.playlist') || [],
      title: get(state, 'categoryVideo.data.title') || '',
      feedid: get(state, 'categoryVideo.data.feedid') || ''
    },
    categoryPage: get(state, 'categoryPage') || {},
    categoryAllFeed: {
      posts: get(state, 'categoryAllFeed.data.posts') || [],
      totalPages: get(state, 'categoryAllFeed.data.totalPages'),
      totalPosts: get(state, 'categoryAllFeed.data.totalPosts')
    }
  };
}

News.contextType = UserContext;

function mapDispatchToProps(dispatch) {
  return {
    nextPage(url) {
      dispatch(push(url));
    }
  };
}

News.propTypes = {
  config: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired,
  categoryPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  categoryFeaturedFeed: PropTypes.shape({
    source: PropTypes.string,
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({})),
    category: PropTypes.object,
    error: PropTypes.bool
  }).isRequired,
  categoryVideo: PropTypes.shape({
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    feedid: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  categoryAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    totalPages: PropTypes.number,
    totalPosts: PropTypes.number
  }).isRequired,
  nextPage: PropTypes.func.isRequired
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(props => <News {...props} />)
);
